/*
* @Author: tengmaoqing
* @Date:   2018-05-07 11:16:41
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-14 09:42:18
*/
import Cookies from 'js-cookie';

export const getLocales = webpackContext => {
  let maps = {};
  webpackContext.keys().forEach(n => {
    maps[n.replace(/\.\/([\w\W]+)\.js$/, '$1')] = webpackContext(n);
  });
  return maps;
};

export const getLanguage = (messages) => {
  const language = Cookies.get('language');
  if (messages) {
    return messages[language] ? language : 'zh-CN';
  }

  return language || 'zh-CN';
  // Cookies.get('language') || 'zh-CN'
};

export const setLanguage = lang => lang && Cookies.set('language', lang, {
  expires: 60
});
